<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt/>
      </a>
      <!-- <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt/>
      </a> -->
    </div>
    <div class="box"></div>
    <div class="title-bj">
      <div class="title">{{ model.title }}</div>
      <div class="priceBox">
        <span
          class="span"
        >会议时间：{{
            model.startTime.slice(0, model.startTime.length - 8)
          }} ~ {{ model.endTime.slice(0, model.endTime.length - 8) }}</span>
        <span class="span">地点：{{ model.region }}</span>
      </div>
    </div>
    <div class="sign" :model="model">
      <div class="img">
        <img :src="model.thumbApp" alt="">
      </div>
      <div class="input">
        <input v-model="model.phoneNumber" type="text" placeholder="请输入电话号码" @input="handleInput">
      </div>
			<div class="radio">
				<div v-for="(item, index) in userList" :class="{'checked': item.checked}" @click="check(item, index)">
					<!-- <input type="radio" name="user" @change="select($event, item)"> -->
					<span>{{item.name}}</span>
				</div>
			</div>
      <div class="btn">
        <button v-if="selData!=''" @click="btn">餐券核销</button>
				<button v-else @click="btn">{{$route.path == '/detail/signIn' ? '获取签到二维码': '餐券核销'}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      model: {
        startTime: '',
        endTime: ''
      },
      userList: [],
      userId: '',
      selData: ''
    }
  },
  created () {
    this.content()
  },
  methods: {
    select (e, item) {
      this.selData = item
    },
    check (item, index) {
      this.userList.map((elem, n) => {
        if (index == n) elem.checked = true
        else elem.checked = false
      })
      this.userList = [...this.userList]
      this.selData = item
    },
    content () {
      this.$axios
        .post(`api/web/phone/content/detail/${this.$route.query.contentId}`, {})
        .then(res => {
          if (res.code == 200) {
            this.model = res.data
          }
        })
    },
    handleInput (e) {
      let value = e.target.value
      let reg = /^\d{11}$/
      let patt = /^[1][3-9][\d]{9}/
      if (reg.test(value) && patt.test(value)) {
        const param = {
				  conferenceId: this.$route.query.contentId,
				  phoneNumber: this.model.phoneNumber
        }
        if (this.$route.path == '/detail/signInMeal') { this.signInMealSubmit(param) }
      }
    },
    btn () {
      if (this.model.phoneNumber == '') {
        this.MessageBox.alert('请输入电话号码').then(action => {
        })
        return
      }
      const param = {
        conferenceId: this.$route.query.contentId,
        phoneNumber: this.model.phoneNumber
      }
      if (this.$route.path == '/detail/signIn') { this.signInSubmit(param) } else if (this.$route.path == '/detail/signInMeal') { this.sureSubmit(param) }
    },
    signInSubmit (param) {
      this.$axios
			  .post(`/api/web/phone/conference/getSignQRCode`, param)
			  .then(res => {
			    if (res.code == 200) {
            if (res.data.length == 0) {
              this.MessageBox.alert('此手机号码未报名会议或报名尚未审核通过').then(action => {})
            } else {
              this.$axios.post(`/api/web/phone/conference/resetSessionSign?attendeeId=${res.data[0].id}`).then(res => {})
              this.$router.push({
							  path: `/detail/signinCode`,
							  query: {
							    // data: JSON.stringify(res.data),
							    contentId: this.$route.query.contentId,
                  phoneNumber: this.model.phoneNumber
							  }
              })
            }
			    } else {
			      this.MessageBox.alert(res.message).then(action => {
			      })
			    }
			  })
    },
    signInMealSubmit (param) {
      this.$axios
			  .post('/api/web/phone/conference/mealAttendee', Object.assign(param, this.$route.query))
			  .then(res => {
			    if (res.code == 200) {
            if (res.data.length == 0) {
              this.MessageBox.alert('此手机号码未报名会议或报名尚未审核通过').then(action => {
              })
            } else {
              this.userList = res.data.length > 1 ? res.data : []
              this.selData = res.data.length == 1 ? res.data[0] : ''
            }
			    } else {
			      this.MessageBox.alert(res.message).then(action => {})
			    }
			  })
    },
    sureSubmit () {
      if (this.selData !== '') {
        this.$axios.post(`/api/web/phone/conference/resetSessionSign?attendeeId=${this.selData.id}`).then(res => {})
        this.$router.push({
				  path: `/detail/signinCode`,
				  query: {
				    data: JSON.stringify(this.$route.query),
				    contentId: this.$route.query.contentId,
            phoneNumber: this.model.phoneNumber,
            isMealSign: 1,
            id: this.selData.id
				  }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.tip {
  font-size: 12px;
  color: #9f9f9f;
  margin: 20px 24px;
  text-align: left;
}

.priceBox {
  position: relative;
}

.TicketPrice {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
}

.title-bj {
  padding: 26px;
  margin: 22px 12px 0;
  min-height: 68px;
  background: url("../assets/img/dingdan_bg@3x.png");
  background-size: 100% 100%;
  position: relative;
}

.span {
  text-align: left;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}

.title {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
}

.sign {
  height: 100%;
  background: #fff;
  border-radius: 10px;
  // z-index: -1;
  margin: -40px 10px;
  padding: 50px 12px 10px;

  .img {
    img {
      width: 100%;
      border-radius: 10px;
    }
  }

  .input {
    text-align: left;
    margin-top: 24px;
    padding: 10px;
    font-size: 14px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
  }

  .btn {
    left: 32%;
    margin-top: 20%;

    button {
      height: 40px;
      color: #fff;
      background: #71c4f1;
      border: none;
      border-radius: 20px;
      font-size: 14px;
      padding: 0 20px;
    }
  }
}

/* 使用webkit内核的浏览器 */
::-webkit-input-placeholder {
  color: #9f9f9f;
  line-height: normal;
  padding-top: 0.06rem;
}

/* Firefox版本4-18 */
:-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* Firefox版本19+ */
::-moz-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

/* IE浏览器 */
:-ms-input-placeholder {
  color: #9f9f9f;
  padding-top: 0.06rem;
}

.p {
  margin: 9px 10px 0;
  font-size: 12px;
}

.box {
  height: 56px;
}

.body {
  position: fixed;
  width: 100%;
  height: 100%;
  // background-color: #fff;
}

.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;

  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;

    img{
      height: 35px;
    }
  }

  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.radio {
  text-align: left;
	margin: 10px 0;

	div {
		height: 28px;
		line-height: 28px;
		// display: flex;
		border: 1px solid #ddd;
		border-radius: 15px;
		padding: 5px 10px;
		margin-bottom: 5px;
		text-align: center;
	}
	input {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
	span {
		display: block;
		margin-top: 0;
	}
	.checked {
		color: #fff;
		background: #71c4f1;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/signin.vue